<template>
  <div>
    <el-dialog
      v-if="visible"
      :title="title"
      :visible="visible"
      show-close
      width="90%"
      top="5vh"
      :close-on-click-modal="false"
      :before-close="() => close()"
      :modal-append-to-body="false"
      :modal="false"
    >
      <Main
        ref="main"
        :orderGoodsCode="orderGoodsCode"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    orderGoodsCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
